import styled from "styled-components/macro"
import { LabelExtra } from "./elements"
import dotted from "../assets/images/dotted.svg"

export const Planets = styled.div`
  transition: all .5s ease-in-out;
  overflow: hidden;
`

export const PlanetBadge = styled.div`
  background: transparent;
  position: absolute;
  top: 68px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`

export const PlanetsProgress = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Planet = styled.div`
  width: 100%;
  height: 72px;
  background-color: #fff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 ${props => props.theme.padding};
  border-radius: 5px;
  margin: 0 0 8px;
  box-shadow: ${props => props.isCurrent && props.isShown ? '0px 2px 4px #0003' : ''};
`

export const PassedPlanets = styled(Planets)`
  max-height: ${props => props.isShown ? '250px' : '0'};
  opacity: ${props => props.isShown ? 1 : 0};
`

export const CurrentPlanet = styled(Planets)`
  overflow: visible;
  opacity: ${props => props.isShown ? 1 : 0};
`

export const ToPassPlanets = styled(Planets)`
  max-height: ${props => props.isShown ? '250px' : '0'};
  opacity: ${props => props.isShown ? 0.72 : 0};
`

export const TogglePlanets = styled(Planet)`
  justify-content: center;
  font-weight: bold;
  color: ${props => props.theme.colors.orange};
  height: 40px;
  padding: 10px 0;
  margin: 0;
  opacity: 1;
  cursor: pointer;
`

export const PlanetIcon = styled.div`
  position: relative;
  width: 32px;
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    color: transparent;
    width: 32px;
    height: 32px;
    background-color: ${props => props.isShown ? props.theme.colors.planetBase : "transparent"};
    border-radius: 50%;
    position: absolute;
    top: 20px;
  }
  
  &.not-passed {
    opacity: 40%
  }
  
  &.up::before {
    position: absolute;
    content: '';
    width: 32px;
    height: 36px;
    background: url(${dotted}) no-repeat top;
    top:0;
  }
  &.mid {
    background: url(${dotted}) no-repeat top;
  }
  &.down::before {
    position: absolute;
    content: '';
    width: 32px;
    height: 36px;
    background: url(${dotted}) no-repeat bottom;
    bottom:0; 
  }   
`

export const PlanetScore = styled.div`
  margin-right: auto;
`

export const PlanetTitle = styled(LabelExtra)`
  font-size: ${props => props.theme.fontSize.header};
  font-weight: 900;
  display: block;
  line-height: 22px;
  color: ${props => props.header ? "#f39822" : ""};
  padding-right: ${props => props.header ? "5px" : 0};
`

export const PlanetState = styled(LabelExtra)`
  font-size: ${props => props.theme.fontSize.small};
  line-height: 18px;
  white-space: nowrap;
`

export const StarsText = styled(PlanetState)`
  font-size: ${props => props.theme.fontSize.small};
  line-height: 18px;
  cursor: pointer;
  direction: ltr;
  width: 100%;
`

export const PlanetDescription = styled.div`
  padding: 0 10px;
  height: 40px;
  display: flex;
  flex-direction: column;
  width:100%;
`

export const StarsDescription = styled(PlanetDescription)`
  justify-content: flex-end;
`
export const FlexRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;
`

